import clsx, { ClassValue } from 'clsx';

import { customAlphabet } from 'nanoid';
import { twMerge } from 'tailwind-merge';

import {
    MaxLengthStoryblok,
    MinLengthStoryblok,
    PatternStoryblok,
    RequiredStoryblok,
} from '@/types/storyblok/storyblok-types';

export const findValidators = (validators: any) => {
    if (!validators) return;
    const required = validators.find((item: RequiredStoryblok) => item.component === 'required');
    const maxLength = validators?.find((item: MaxLengthStoryblok) => item?.maxLength);
    const minLength = validators.find((item: MinLengthStoryblok) => item.minLength);
    const pattern = validators.find((item: PatternStoryblok) => item.regexPattern);

    return { required, maxLength, minLength, pattern };
};
export function cn(...inputs: ClassValue[]) {
    return twMerge(clsx(inputs));
}

export const nanoid = customAlphabet('0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz', 7);

export function fixDuplicateLanguagePath(path) {
    const segments = path.split('/').filter(Boolean); // remove empty strings
    if (segments.length >= 2 && segments[0] === segments[1]) {
        segments.splice(1, 1); // remove the second occurrence
    }
    return `/${segments.join('/')}/`;
}
